import { render, staticRenderFns } from "./editorMessagePopover.vue?vue&type=template&id=4e7207c0&"
import script from "./editorMessagePopover.vue?vue&type=script&lang=js&"
export * from "./editorMessagePopover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports